import { SortDirection, VehicleListDTO } from 'src/app/base/models/models.swagger.generated';
import { defineDynamicEntityDefinition, textColumn } from 'src/app/base/shared/dynamic/dynamic-entity-definition';

export const vehiclesDynamicDefinition = defineDynamicEntityDefinition<VehicleListDTO, VehicleListDTO, VehicleListDTO>({
  entityName: 'vehicle',
  primaryKey: 'id',
  defaultSort: { field: 'VIN', direction: SortDirection.Ascending },
  grid: {
    searchFields: ['vin', 'manufacturer', 'brand', 'model'],
    columns: [
      { field: 'id', headerKey: 'i18n.shared.fields.id', type: 'number', visible: false, allowFiltering: false },
      textColumn<VehicleListDTO>('vin', 'i18n.domain.vehicles.columns.vin'),
      textColumn<VehicleListDTO>('manufacturer', 'i18n.domain.vehicles.columns.manufacturer'),
      textColumn<VehicleListDTO>('brand', 'i18n.domain.vehicles.columns.brand'),
      textColumn<VehicleListDTO>('model', 'i18n.domain.vehicles.columns.model'),
      { field: 'modelYear', headerKey: 'i18n.domain.vehicles.columns.model-year', type: 'number', width: '130px', filter: { kind: 'number' } },
      // Derived from the assigned profile's Name, not a plain column on Vehicle — not filterable/sortable server-side.
      textColumn<VehicleListDTO>('samplingProfileName', 'i18n.domain.vehicles.columns.sampling-profile', { allowFiltering: false, sortable: false }),
    ],
  },
  form: {
    fields: [],
    layout: [],
  },
  // Vehicles are read-only here (created via device ingestion) — add/edit are never triggered
  // since the grid disables allowAdding/allowEditing/allowDeleting, so these are unused identity pass-throughs.
  mapToCreate: (formValue: VehicleListDTO): VehicleListDTO => formValue,
  mapToUpdate: (formValue: VehicleListDTO): VehicleListDTO => formValue,
});
